import React, { useMemo, useEffect } from "react";
import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { debounce } from "lodash";

const StrokeControl = ({
  inputRef,
  attribute,
  placeholder,
  attributeType,
  handleInputChange,
  elementAttributes,
}: any) => {
  // Debounce only the color input
  const debouncedColorChange = useMemo(
    () =>
      debounce((value: string) => {
        handleInputChange(attributeType, value);
      }, 100),
    [attributeType, handleInputChange]
  );

  useEffect(() => {
    return () => {
      debouncedColorChange.cancel();
    };
  }, [debouncedColorChange]);

  return (
    <div>
      <div className="flex flex-col gap-3 border-b border-borderColor py-5 px-2">
        <div className="w-full flex h-full items-start justify-between px-1">
          <h3 className="text-[10px] uppercase">Stroke</h3>
          <h3 className="text-[10px] uppercase">Stroke Width</h3>
        </div>

        <div className="flex gap-x-1 w-full">
          {/* Stroke Color - Debounced */}
          <div
            className="flex w-1/2 items-center h-10 gap-2 rounded-lg border border-grey-200"
            onClick={() => inputRef.current?.click()}
          >
            <input
              type="color"
              value={attribute || "#000000"}
              ref={inputRef}
              onChange={(e) => debouncedColorChange(e.target.value)}
              className="rounded-l-lg h-full"
            />
            <Label>{attribute || "-"}</Label>
          </div>

          {/* Stroke Width - Instant */}
          <div className="flex items-center w-1/2 rounded-sm">
            <Input
              type="number"
              id="strokeWidth"
              placeholder="0"
              value={elementAttributes.strokeWidth || 0}
              className="input-ring bg-transparent text-white placeholder"
              onChange={(e) => handleInputChange("strokeWidth", e.target.value)}
              min={0}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrokeControl;
